export default {
    data: [
        'ODT',
        'CLN',
        'NN',
        'ONT',
        'Đất khác'
    ]
}